"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    messageBarGroupClassNames: function() {
        return messageBarGroupClassNames;
    },
    useMessageBarGroupStyles_unstable: function() {
        return useMessageBarGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const messageBarGroupClassNames = {
    root: 'fui-MessageBarGroup'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bf5fcs: "f4cll0y",
        vin17d: "fy8si0b"
    },
    enter: {
        Bv12yb3: "f1dg9w1v"
    },
    exit: {
        Bv12yb3: "fu80iee"
    }
}, {
    d: [
        ".f4cll0y{animation-fill-mode:forwards;}",
        ".fy8si0b{animation-duration:var(--durationNormal);}",
        ".f1dg9w1v{animation-name:fngeioi;}",
        ".fu80iee{animation-name:fk0lfw7;}"
    ],
    k: [
        "@keyframes fngeioi{from{opacity:0;transform:translateY(-100%);}to{opacity:1;transform:translateY(0);}}",
        "@keyframes fk0lfw7{from{opacity:1;}to{opacity:0;}}"
    ]
});
const useMessageBarGroupStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(messageBarGroupClassNames.root, state.root.className);
    state.enterStyles = (0, _react.mergeClasses)(styles.base, styles.enter);
    state.exitStyles = (0, _react.mergeClasses)(styles.base, styles.exit);
    return state;
}; //# sourceMappingURL=useMessageBarGroupStyles.styles.js.map
